/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNetworkBoxAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M17.975 11.705a2.5 2.5 0 0 1 2.516 4.074l.389 1.357a2.5 2.5 0 1 1-2.152 4.113l-3.026.757a2.5 2.5 0 1 1-1.372-3.78l1.968-3.184a2.499 2.499 0 0 1 1.677-3.337zm-4 8.563a.499.499 0 1 0-.706.705.499.499 0 0 0 .706-.705zm6.646-1.147a.5.5 0 1 0 0 1.001.5.5 0 0 0 0-1zm-4.749.414c.052.109.095.221.13.334l2.136-.533c.071-.633.38-1.192.835-1.592l-.322-1.125c-.3.004-.598-.047-.883-.15zm3.103-5.767a.499.499 0 1 0-.706.705.499.499 0 0 0 .706-.705z" />
        <path d="M11.47 2.153a1.001 1.001 0 0 1 1.06 0l8 5a1 1 0 0 1 0 1.695L13 13.554V16h-2v-2.446l-6-3.75v5.642l4.53 2.832-1.06 1.695-5-3.125A1 1 0 0 1 3 16V8a1 1 0 0 1 .47-.847zM5.886 8 12 11.82 18.113 8 12 4.18z" />
      </g>
    </g>
  </Icon>
);
export { SvgNetworkBoxAlt as NetworkBoxAlt };
